export const normalizeAccountFlags = (userData) => ({
  accountManagedByTeacher: userData?.accountManagedByTeacher === true,
  mustChangePassword: userData?.mustChangePassword === true,
});

export const requiresForcedPasswordChange = (userProfile) =>
  userProfile?.role === "student" &&
  userProfile?.accountManagedByTeacher === true &&
  userProfile?.mustChangePassword === true;
